/**
 * Punto ÚNICO de verdad de los permisos de SiLabVet en el frontend.
 *
 * Espejo del enum del backend (`src/auth/permisos.ts` en silabvet-backend);
 * los códigos llegan ya traducidos en `sesion.permisos` al hacer login.
 * Cualquier permiso nuevo se agrega allá, acá y en el script SQL de SIGERH
 * (`scripts/sigerh-componentes-silabvet.sql`).
 */
export enum Permiso {
  RECEPCIONES_VER = 'recepciones.ver',
  RECEPCIONES_CREAR = 'recepciones.crear',
  RECEPCIONES_PRIVADA_CREAR = 'recepciones.privada.crear',
  RECEPCIONES_VIGILANCIA_CREAR = 'recepciones.vigilancia.crear',
  RECEPCIONES_EDITAR = 'recepciones.editar',
  /** Copiar un RT-01 existente (de cualquier regional) a una regional elegida. */
  RECEPCIONES_COPIAR = 'recepciones.copiar',  RECIBO_GENERAR = 'recepciones.recibo.generar',
  RECIBO_REUTILIZAR = 'recepciones.recibo.reutilizar',
  RECIBO_ASOCIAR = 'recepciones.recibo.asociar',
  SEPARACION_VER = 'separacion.ver',
  SEPARACION_PROCESAR = 'separacion.procesar',
  CONFIRMACION_VER = 'confirmacion.ver',
  CONFIRMACION_CONFIRMAR = 'confirmacion.confirmar',
  BRUCELOSIS_VER = 'serologia.brucelosis.ver',
  BRUCELOSIS_RESULTADOS = 'serologia.brucelosis.resultados',
  BRUCELOSIS_LECHE_VER = 'serologia.brucelosis.leche.ver',
  BRUCELOSIS_LECHE_RESULTADOS = 'serologia.brucelosis.leche.resultados',
  TUBERCULOSIS_VER = 'serologia.tuberculosis.ver',
  TUBERCULOSIS_RESULTADOS = 'serologia.tuberculosis.resultados',
  BRUCELOSIS_ANILLO_VER = 'serologia.brucelosis.anillo.ver',
  BRUCELOSIS_ANILLO_RESULTADOS = 'serologia.brucelosis.anillo.resultados',
  HEMOGRAMA_VER = 'hematologia.hemograma.ver',
  HEMOGRAMA_RESULTADOS = 'hematologia.hemograma.resultados',
  ANEMIA_EQUINA_VER = 'virologia.anemia-equina.ver',
  ANEMIA_EQUINA_RESULTADOS = 'virologia.anemia-equina.resultados',
  LARINGOTRAQUEITIS_VER = 'virologia.laringotraqueitis.ver',
  LARINGOTRAQUEITIS_RESULTADOS = 'virologia.laringotraqueitis.resultados',
  NEWCASTLE_VER = 'virologia.newcastle.ver',
  NEWCASTLE_RESULTADOS = 'virologia.newcastle.resultados',
  INFLUENZA_AVIAR_VER = 'virologia.influenza-aviar.ver',
  INFLUENZA_AVIAR_RESULTADOS = 'virologia.influenza-aviar.resultados',
  PESTE_PORCINA_CLASICA_VER = 'virologia.peste-porcina-clasica.ver',
  PESTE_PORCINA_CLASICA_RESULTADOS = 'virologia.peste-porcina-clasica.resultados',
  PESTE_PORCINA_AFRICANA_VER = 'virologia.peste-porcina-africana.ver',
  PESTE_PORCINA_AFRICANA_RESULTADOS = 'virologia.peste-porcina-africana.resultados',
  PERFIL_PORCINO_VER = 'virologia.perfil-porcino.ver',
  PERFIL_PORCINO_RESULTADOS = 'virologia.perfil-porcino.resultados',
  PERFIL_BOVINO_VER = 'virologia.perfil-bovino.ver',
  PERFIL_BOVINO_RESULTADOS = 'virologia.perfil-bovino.resultados',
  TITULACION_VACUNA_VER = 'virologia.titulacion-vacuna-newcastle.ver',
  TITULACION_VACUNA_RESULTADOS = 'virologia.titulacion-vacuna-newcastle.resultados',
  BRONQUITIS_VER = 'virologia.bronquitis.ver',
  BRONQUITIS_RESULTADOS = 'virologia.bronquitis.resultados',
  INFLUENZA_AVIAR_PCR_VER = 'biologia-molecular.influenza-aviar.ver',
  INFLUENZA_AVIAR_PCR_RESULTADOS = 'biologia-molecular.influenza-aviar.resultados',
  LARINGOTRAQUEITIS_PCR_VER = 'biologia-molecular.laringotraqueitis.ver',
  LARINGOTRAQUEITIS_PCR_RESULTADOS = 'biologia-molecular.laringotraqueitis.resultados',
  NEWCASTLE_PCR_VER = 'biologia-molecular.newcastle.ver',
  NEWCASTLE_PCR_RESULTADOS = 'biologia-molecular.newcastle.resultados',
  MONITOREO_AMBIENTAL_VER = 'bacteriologia.monitoreo-ambiental.ver',
  MONITOREO_AMBIENTAL_RESULTADOS = 'bacteriologia.monitoreo-ambiental.resultados',
  BACTERIOLOGICO_AGUA_VER = 'bacteriologia.bacteriologico-agua.ver',
  BACTERIOLOGICO_AGUA_RESULTADOS = 'bacteriologia.bacteriologico-agua.resultados',
  AISLAMIENTO_BACTERIANO_VER = 'bacteriologia.aislamiento-bacteriano.ver',
  AISLAMIENTO_BACTERIANO_RESULTADOS = 'bacteriologia.aislamiento-bacteriano.resultados',
  CULTIVO_SALMONELLA_HONGOS_VER = 'bacteriologia.cultivo-salmonella-hongos.ver',
  CULTIVO_SALMONELLA_HONGOS_RESULTADOS = 'bacteriologia.cultivo-salmonella-hongos.resultados',
  AISLAMIENTO_BACTERIAS_HONGOS_VER = 'bacteriologia.aislamiento-bacterias-hongos.ver',
  AISLAMIENTO_BACTERIAS_HONGOS_RESULTADOS = 'bacteriologia.aislamiento-bacterias-hongos.resultados',
  AISLAMIENTO_M_BOVIS_VER = 'bacteriologia.aislamiento-m-bovis.ver',
  AISLAMIENTO_M_BOVIS_RESULTADOS = 'bacteriologia.aislamiento-m-bovis.resultados',
  AISLAMIENTO_SALMONELLA_VER = 'bacteriologia.aislamiento-salmonella.ver',
  AISLAMIENTO_SALMONELLA_RESULTADOS = 'bacteriologia.aislamiento-salmonella.resultados',
  RECUENTO_MESOFILAS_HONGOS_VER = 'bacteriologia.recuento-mesofilas-hongos.ver',
  RECUENTO_MESOFILAS_HONGOS_RESULTADOS = 'bacteriologia.recuento-mesofilas-hongos.resultados',
  LEPTOSPIRA_HUMANO_VER = 'leptospirosis.leptospira-humano.ver',
  LEPTOSPIRA_HUMANO_RESULTADOS = 'leptospirosis.leptospira-humano.resultados',
  AISLAMIENTO_LEPTOSPIRA_VER = 'leptospirosis.aislamiento-leptospira.ver',
  AISLAMIENTO_LEPTOSPIRA_RESULTADOS = 'leptospirosis.aislamiento-leptospira.resultados',
  VACUNA_PAPILOMA_VER = 'leptospirosis.autovacuna-papiloma.ver',
  VACUNA_PAPILOMA_RESULTADOS = 'leptospirosis.autovacuna-papiloma.resultados',
  RABIA_VER = 'rabia.ifd.ver',
  RABIA_RESULTADOS = 'rabia.ifd.resultados',
  RABIA_PRUEBA_BIOLOGICA_VER = 'rabia.prueba-biologica.ver',
  RABIA_PRUEBA_BIOLOGICA_RESULTADOS = 'rabia.prueba-biologica.resultados',
  EEB_VER = 'eeb.diagnostico.ver',
  EEB_RESULTADOS = 'eeb.diagnostico.resultados',
  IXODICIDA_VER = 'ixodologia.evaluacion-ixodicida.ver',
  IXODICIDA_RESULTADOS = 'ixodologia.evaluacion-ixodicida.resultados',
  ESPERMOGRAMA_VER = 'reproduccion.espermograma.ver',
  ESPERMOGRAMA_RESULTADOS = 'reproduccion.espermograma.resultados',
  NOSEMA_VER = 'parasitologia.nosema.ver',
  NOSEMA_RESULTADOS = 'parasitologia.nosema.resultados',
  GBG_VER = 'parasitologia.gusano-barrenador.ver',
  GBG_RESULTADOS = 'parasitologia.gusano-barrenador.resultados',
  AETHINA_TUMIDA_VER = 'parasitologia.aethina-tumida.ver',
  AETHINA_TUMIDA_RESULTADOS = 'parasitologia.aethina-tumida.resultados',
  // Ectoparásitos: una sola pantalla para todas las especies.
  ECTOPARASITOS_VER = 'parasitologia.ectoparasitos.ver',
  ECTOPARASITOS_RESULTADOS = 'parasitologia.ectoparasitos.resultados',
  // Endoparásitos: una sola pantalla para todas las especies.
  ENDOPARASITOS_VER = 'parasitologia.endoparasitos.ver',
  ENDOPARASITOS_RESULTADOS = 'parasitologia.endoparasitos.resultados',
  REVISION_VER = 'resultados.revision.ver',
  REVISION_RESOLVER = 'resultados.revision.resolver',
  EXCEPCIONES_VER = 'excepciones.ver',
  EXCEPCIONES_RESOLVER = 'excepciones.resolver',
  CATALOGO_TIPOS_VER = 'catalogos.tipos.ver',
  CATALOGO_TIPOS_GESTIONAR = 'catalogos.tipos.gestionar',
  CATALOGOS_VER = 'catalogos.ver',
  CATALOGOS_GESTIONAR = 'catalogos.gestionar',
  CATALOGOS_SINCRONIZAR = 'catalogos.sincronizar',
  SERVICIOS_VER = 'servicios.ver',
  SERVICIOS_GESTIONAR = 'servicios.gestionar',
  PLANTILLAS_VER = 'plantillas.ver',
  PLANTILLAS_EDITAR = 'plantillas.editar',
  PLANTILLAS_ENCABEZADO = 'plantillas.encabezado',
  USUARIOS_VER = 'usuarios.ver',
  USUARIOS_REGIONAL = 'usuarios.regional',
  /** Ver la información de todas las regionales, no solo la propia. */
  REGIONALES_TODAS = 'regionales.todas',
}
